import { render } from "./ReleaseEngineering.vue?vue&type=template&id=52983f5c&scoped=true&ts=true&lang=pug"
import script from "./ReleaseEngineering.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReleaseEngineering.vue?vue&type=script&setup=true&lang=ts"

import "./ReleaseEngineering.vue?vue&type=style&index=0&id=52983f5c&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52983f5c"]])

export default __exports__